import styled from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

export const Container = styled.footer<PaddingProps>`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: ${themeGet('colors.surface.inverted')};

  ${padding}
`

// Layout container inside <footer> — <header> here was a landmark misuse.
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
`
